import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import "./layout.css";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import AccountCircleOutlinedIcon from "@mui/icons-material/AccountCircleOutlined";
import NotificationsIcon from "@mui/icons-material/Notifications";
import MenuIcon from "@mui/icons-material/Menu";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import IconButton from "@mui/material/IconButton";
import Sidebar from "../sidebar/Sidebar";
// import { Box } from "@mui/system";
import {
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Drawer,
  Menu,
  MenuItem,
  TextField,
  Typography,
} from "@mui/material";
import { ReactComponent as CalendarIcon } from "../../Assets/images/calender.svg";
import {
  logout,
  updateUser,
  userFlagOff,
} from "../../Redux/Actions/userAction";
import { useDispatch } from "react-redux";
import { imgUrl } from "../../api/api";
import toast from "react-hot-toast";
import { makeStyles } from "@material-ui/core";
import { CalendarMonthOutlined } from "@mui/icons-material";
const useStyle = makeStyles((theme) => {
  return {
    sideBar: {
      [theme.breakpoints.down("sm")]: {
        width: "70px !important",
      },
      // [theme.breakpoints.up('sm')]:{
      //   width:'18vw !important'
      // }
    },
  };
});
function Layout({ children, title, user }) {
  const location = useLocation();
  const classes = useStyle();
  const [day, setDay] = useState("");
  const [date, setDate] = useState("");
  const [month, setMonth] = useState("");
  const [year, setYear] = useState("");
  const [anchorEl, setAnchorEl] = useState(null);
  const [openProfileDialog, setOpenProfileDialog] = useState(false);
  const [username, setUsername] = useState(user.username);
  const [password, setPassword] = useState("");
  const [confirmpassword, setConfirmPassword] = useState("");
  const [email, setEmail] = useState(user.email);
  const open = Boolean(anchorEl);
  const getProfileImageUrl = (u) => {
    const url = u?.image?.url;
    if (!url) return "";
    return url.startsWith("http") ? url : `${imgUrl}${url.startsWith("/") ? "" : "/"}${url}`;
  };
  const [image, setImage] = useState(() => (user?.image?.url ? (user.image.url.startsWith("http") ? user.image.url : `${imgUrl}${user.image.url.startsWith("/") ? "" : "/"}${user.image.url}`) : ""));
  const [imgFile, setImgFile] = useState(null);
  const [profileError, setProfileError] = useState("");
  const [openDrawer, setOpenDrawer] = useState(false);
  const [sidebarOpen, setSidebarOpen] = useState(true);
  useEffect(() => {
    if (openProfileDialog && user) {
      setUsername(user.username ?? "");
      setEmail(user.email ?? "");
      setPassword("");
      setConfirmPassword("");
      setImage(getProfileImageUrl(user));
      setImgFile(null);
      setProfileError("");
    }
  }, [openProfileDialog, user]);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = (type, obj) => {
    setAnchorEl(null);
    // setOpenProfileDialog(true);
  };
  const openprofile = () => {
    setAnchorEl(null);
    setOpenProfileDialog(true);
  };
  const dispatch = useDispatch();
  useEffect(() => {
    getDay();
  }, []);
  const getDay = () => {
    const date = new Date();
    setDate(date.getDate());
    setYear(date.getFullYear());
    // console.log("day", date.getDay());
    switch (date.getDay()) {
      case 1:
        setDay("Monday");
        break;
      case 2:
        setDay("Tuesday");
        break;
      case 3:
        setDay("Wednesday");
        break;
      case 4:
        setDay("Thursday");
        break;
      case 5:
        setDay("Friday");
        break;
      case 6:
        setDay("Saturday");
        break;
      case 0:
        setDay("Sunday");
        break;
      default:
        setDay("");
    }
    switch (date.getMonth()) {
      case 0:
        setMonth("Jan");
        break;
      case 1:
        setMonth("Feb");
        break;
      case 2:
        setMonth("Mar");
        break;
      case 3:
        setMonth("Apr");
        break;
      case 4:
        setMonth("May");
        break;
      case 5:
        setMonth("Jun");
        break;
      case 6:
        setMonth("Jul");
        break;
      case 7:
        setMonth("Aug");
        break;
      case 8:
        setMonth("Sep");
        break;
      case 9:
        setMonth("Oct");
        break;
      case 10:
        setMonth("Nov");
        break;
      case 11:
        setMonth("Dec");
        break;
      default:
        setMonth("");
    }
  };
  const browseUserImage = (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    if (!file.type.startsWith("image/")) {
      toast.error("Please select an image file (JPG, PNG, etc.)");
      return;
    }
    if (image && image.startsWith("blob:")) URL.revokeObjectURL(image);
    setImage(URL.createObjectURL(file));
    setImgFile(file);
    setProfileError("");
  };
  const update = async () => {
    setProfileError("");
    const trimUsername = username?.trim();
    const trimEmail = email?.trim();
    if (!trimUsername) {
      setProfileError("Username is required.");
      return;
    }
    if (!trimEmail) {
      setProfileError("Email is required.");
      return;
    }
    if (password && password.length < 6) {
      setProfileError("Password must be at least 6 characters.");
      return;
    }
    if (password !== confirmpassword) {
      setProfileError("Password and Confirm Password do not match.");
      return;
    }
    const form = new FormData();
    form.append("username", trimUsername);
    form.append("email", trimEmail);
    if (password) form.append("password", password);
    if (imgFile) form.append("content", imgFile);
    const result = await dispatch(updateUser(user._id, form));
    if (result) {
      toast.success("User updated!");
      setOpenProfileDialog(false);
      dispatch(userFlagOff());
    }
  };
  // const onOpenWebPlayer=()=>{
  //  window.open('http://localhost:3000/web-player','_blank')

  // }
  return (
    <>
      <div className="layout-container">
        <div className={`side-bar-wrapper ${sidebarOpen ? 'sidebar-open' : 'sidebar-closed'}`}>
          <div className={`side-bar ${classes.sideBar} ${sidebarOpen ? 'sidebar-open' : 'sidebar-closed'}`}>
            <Sidebar user={user} />
          </div>
        </div>
        <div className={`body ${sidebarOpen ? 'body-sidebar-open' : 'body-sidebar-closed'}${location.pathname === '/screen' ? ' screen-page-bg' : ''}`}>
          <div className="body-header">
            <div className="body-header-left">
              {/* <div className="titles"> */}
              <div className="title-logo">
                <IconButton 
                  className="sidebar-toggle-btn"
                  onClick={() => setSidebarOpen(!sidebarOpen)}
                  sx={{
                    backgroundColor: 'transparent',
                    color: 'white',
                    width: '100%',
                    height: '100%',
                    padding: 0,
                    minWidth: 'auto',
                    '&:hover': {
                      backgroundColor: 'rgba(255, 255, 255, 0.1)',
                    },
                  }}
                >
                  {sidebarOpen ? <ChevronLeftIcon sx={{ fontSize: '20px' }} /> : <ChevronRightIcon sx={{ fontSize: '20px' }} />}
                </IconButton>
              </div>
              <p className="form-title">{title}</p>
              {/* </div> */}
            </div>
            <div className="body-header-right">
              <div className={"mobile-menu"}>
                <MenuIcon
                  className="menu-icon"
                  onClick={() => setOpenDrawer(true)}
                />
              </div>
              <div className="body-header-right-inner">
                {/* <Box mr={3}>
                  <button className="upgradePro">Upgrade to Pro</button>
                </Box> */}
                <Box
                  className="time-day"
                  sx={{
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <CalendarMonthOutlined
                    sx={{
                      color: "#008080",
                      marginTop: "-5px",
                    }}
                  />
                  <Typography
                    sx={{
                      paddingLeft: "5px",
                      fontSize: "14px",
                    }}
                  >
                    {`${day},${date} ${month} ${year}`}
                  </Typography>
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    ml: 3,
                  }}
                >
                  {user?.image === undefined ||
                  user?.image === null ||
                  user?.image?.url === undefined ||
                  user?.image?.url === null ||
                  user?.image?.url === "" ? (
                    <AccountCircleIcon
                      style={{
                        color: "#008080",
                        marginTop: "-5px",
                      }}
                      onClick={handleClick}
                      aria-controls={open ? "content-menu" : undefined}
                      aria-haspopup={"true"}
                      aria-expanded={open ? "true" : undefined}
                      id="content-menu-btn"
                    />
                  ) : (
                    <img
                      src={getProfileImageUrl(user)}
                      alt=""
                      style={{
                        height: "36px",
                        width: "36px",
                        borderRadius: "50%",
                        objectFit: "cover",
                        marginTop: "-5px",
                      }}
                      onClick={handleClick}
                      aria-controls={open ? "content-menu" : undefined}
                      aria-haspopup={"true"}
                      aria-expanded={open ? "true" : undefined}
                      id="content-menu-btn"
                    />
                  )}
                  <Typography
                    sx={{
                      paddingLeft: "5px",
                      color: "#6B7A99",
                      fontSize: "13px",
                    }}
                  >
                    {user?.username}
                  </Typography>
                  <Menu
                    id={"content-menu"}
                    anchorEl={anchorEl}
                    open={open}
                    MenuListProps={{
                      "aria-labelledby": "content-menu-btn",
                    }}
                    onClose={handleClose}
                    keepMounted
                    anchorOrigin={{
                      vertical: "top",
                      horizontal: "center",
                    }}
                    transformOrigin={{
                      vertical: "top",
                      horizontal: "center",
                    }}
                  >
                    <MenuItem onClick={openprofile}>Profile</MenuItem>
                    {/* <MenuItem onClick={onOpenWebPlayer}>Web Player</MenuItem> */}
                    <MenuItem onClick={() => dispatch(logout())}>
                      Logout
                    </MenuItem>
                  </Menu>
                </Box>
                <Box
                  sx={{
                    ml: 3,
                  }}
                >
                  <NotificationsIcon
                    sx={{
                      color: "#008080",
                      background: "white",
                      borderRadius: "50%",
                      padding: "8px",
                    }}
                  />
                </Box>
              </div>
            </div>
          </div>

          <div className="body-body">
            <div className="body-body-scroll-able">{children}</div>
          </div>
        </div>
      </div>

      <Dialog
        maxWidth="sm"
        fullWidth
        open={openProfileDialog}
        onClose={() => setOpenProfileDialog(false)}
        PaperProps={{
          sx: {
            borderRadius: "14px",
            border: "1px solid #e5e7eb",
            boxShadow: "0 20px 40px rgba(15, 23, 42, 0.12)",
            overflow: "hidden",
          },
        }}
        sx={{ zIndex: "100000000" }}
      >
        <DialogTitle
          sx={{
            borderBottom: "2px solid #0d9488",
            py: 2,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: 1.5,
            fontFamily: "'Inter', sans-serif",
            fontWeight: 700,
            fontSize: "20px",
            color: "#111827",
          }}
        >
          <AccountCircleOutlinedIcon sx={{ color: "#0d9488", fontSize: 28 }} />
          User Profile
        </DialogTitle>
        <DialogContent sx={{ px: 3, py: 3, pt: 3 }}>
          <Box sx={{ display: "flex", flexDirection: "column", gap: 2.5 }}>
            <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 1.5 }}>
              <Box
                sx={{
                  width: 120,
                  height: 120,
                  borderRadius: "50%",
                  overflow: "hidden",
                  border: "3px solid #e5e7eb",
                  bgcolor: "#f8fafc",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                {image ? (
                  <img
                    src={image}
                    alt=""
                    style={{ width: "100%", height: "100%", objectFit: "cover" }}
                  />
                ) : (
                  <AccountCircleOutlinedIcon sx={{ color: "#94a3b8", fontSize: 64 }} />
                )}
              </Box>
              <input
                hidden
                type="file"
                id="imagebrowse"
                accept="image/*"
                onChange={browseUserImage}
              />
              <Button
                variant="outlined"
                onClick={() => document.getElementById("imagebrowse").click()}
                sx={{
                  borderRadius: "8px",
                  textTransform: "none",
                  fontFamily: "'Inter', sans-serif",
                  fontWeight: 600,
                  color: "#0d9488",
                  borderColor: "#0d9488",
                  "&:hover": { borderColor: "#0f766e", bgcolor: "#f0fdfa" },
                }}
              >
                Upload Photo
              </Button>
              <Typography sx={{ fontSize: "12px", color: "#64748b", fontFamily: "'Inter', sans-serif" }}>
                JPG, PNG or GIF. Max 5MB.
              </Typography>
            </Box>

            {profileError && (
              <Typography sx={{ color: "#dc2626", fontSize: "13px", fontFamily: "'Inter', sans-serif" }}>
                {profileError}
              </Typography>
            )}

            <TextField
              label="Username"
              required
              fullWidth
              size="small"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              sx={{
                "& .MuiOutlinedInput-root": { borderRadius: "8px", fontFamily: "'Inter', sans-serif" },
                "& .MuiInputLabel-root": { fontFamily: "'Inter', sans-serif" },
              }}
            />
            <TextField
              label="Email"
              required
              fullWidth
              size="small"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              sx={{
                "& .MuiOutlinedInput-root": { borderRadius: "8px", fontFamily: "'Inter', sans-serif" },
                "& .MuiInputLabel-root": { fontFamily: "'Inter', sans-serif" },
              }}
            />
            <TextField
              label="New password (leave blank to keep current)"
              fullWidth
              size="small"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="••••••••"
              sx={{
                "& .MuiOutlinedInput-root": { borderRadius: "8px", fontFamily: "'Inter', sans-serif" },
                "& .MuiInputLabel-root": { fontFamily: "'Inter', sans-serif" },
              }}
            />
            <TextField
              label="Confirm password"
              fullWidth
              size="small"
              type="password"
              value={confirmpassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              placeholder="••••••••"
              sx={{
                "& .MuiOutlinedInput-root": { borderRadius: "8px", fontFamily: "'Inter', sans-serif" },
                "& .MuiInputLabel-root": { fontFamily: "'Inter', sans-serif" },
              }}
            />

            <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 1.5, mt: 1 }}>
              <Button
                variant="outlined"
                onClick={() => setOpenProfileDialog(false)}
                sx={{
                  borderRadius: "8px",
                  textTransform: "none",
                  fontFamily: "'Inter', sans-serif",
                  fontWeight: 600,
                  color: "#374151",
                  borderColor: "#d1d5db",
                  "&:hover": { borderColor: "#9ca3af", bgcolor: "#f9fafb" },
                }}
              >
                Cancel
              </Button>
              <Button
                variant="contained"
                onClick={update}
                sx={{
                  borderRadius: "8px",
                  textTransform: "none",
                  fontFamily: "'Inter', sans-serif",
                  fontWeight: 600,
                  bgcolor: "#0d9488",
                  "&:hover": { bgcolor: "#0f766e" },
                }}
              >
                Save
              </Button>
            </Box>
          </Box>
        </DialogContent>
      </Dialog>

      <Drawer
        open={openDrawer}
        anchor={"left"}
        onClose={() => setOpenDrawer(false)}
      >
        <div className="drawer-container">
          <Sidebar user={user} />
        </div>
      </Drawer>
    </>
  );
}
export default Layout;
